// extracted by mini-css-extract-plugin
export default {"wrapper":"OrdersListPage_wrapper__-Eviv","loadingWrapper":"OrdersListPage_loadingWrapper__zzxcY"};